export default __webpack_public_path__ + "static/media/it.1f95c8f2.svg";